import CreateCustomer from "../../modules/customer/create-customer";

const CustomerCreateModal = ({
  isOpen = false,
  onClose = () => {},
  btnFnc = () => {},
}) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-5"
          onClick={handleOverlayClick}
        >
          <div
            className="bg-white rounded-lg shadow-lg max-w-[60rem] w-full h-full md:p-6 p-4 relative overflow-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <CreateCustomer popup={true} closePopUp={onClose} />
          </div>
        </div>
      )}
    </>
  );
};

export default CustomerCreateModal;
